/**
 * Created by Jie Gao on 2017-05-26.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {AnimationHelper} from "../../utils/AnimationHelper";

export class BigWinWhiteBarAnimation extends BaseView {
    private readonly LEVEL_ANIMATE_FLAG:boolean[][] = [[true, false], [false, true], [true, false], [true, true]];
    private readonly LEVEL_POSITION_Y1:number[] = [315, 380, 310, 420];
    private readonly LEVEL_POSITION_Y2:number[] = [315, 380, 310, 435];
    private readonly SPRITES_ROTATIONS:number[] = [45, -45];
    private _layer:PIXI.Container;
    private _whiteBars:TimelineSprite[];
    private _timeline:TimelineLite;

    constructor(layer:PIXI.Container) {
        super();
        this._layer = layer;
    }

    protected initAnimations():void {
        this._whiteBars = [];
        this._timeline = new TimelineLite();
        for(let i = 0; i < this.SPRITES_ROTATIONS.length; i++) {
            const sprite = AnimationHelper.createTimelineSprite(GameResources.getTextures("foreground_respin"));
            sprite.alpha = 1;
            sprite.scale.y = 2;
            sprite.rotation = this.SPRITES_ROTATIONS[i] * Math.PI / 180;
            sprite.x = GameConfig.instance.GAME_WIDTH / 2;
            this._whiteBars.push(sprite);
            this._layer.addChild(sprite);
            sprite.hide();
        }
    }

    public startPresentation(level:number):void {
        const config:boolean[] = this.LEVEL_ANIMATE_FLAG[level];
        this._timeline = new TimelineLite({paused : true});

        if(config[0]) {
            this._timeline.add([
                new TweenLite(this._whiteBars[0], 0, {y : this.LEVEL_POSITION_Y1[level]}),
                this._whiteBars[0].getAnimation([0, 55, 20, 55, 20, 55, 20, 55])
            ], '0');
            this._timeline.add(() => {this._whiteBars[0].show();}, '0.02');
        } else {
            this._whiteBars[0].hide();
        }

        if(config[1]) {
            this._timeline.add(() => {this._whiteBars[1].show();}, '0.02');
            this._timeline.add([
                new TweenLite(this._whiteBars[1], 0, {y : this.LEVEL_POSITION_Y2[level]}),
                this._whiteBars[1].getAnimation([0, 55, 20, 55, 20, 55, 20, 55])
            ], '0');
        } else {
            this._whiteBars[1].hide();
        }
        this._timeline.play();
    }

    public stopAnimation():void {
        this._whiteBars[0].hide();
        this._whiteBars[1].hide();
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
        }
    }
}